export default __webpack_public_path__ + "static/media/openai-chatgpt.c70abfc5.svg";